import React from 'react';
import Styles from './QvExpired.module.scss';

import Favicon from './qv-favicon.svg';
import Logo from './qv-loading.png';

class QvExpired extends React.Component {
  render() {
    return (
      <div
        className={`w-100 h-100 d-flex flex-column flex-default overflow-hidden`}
      >
        <div className={Styles.Container}>
          <div className={Styles.HeaderContainer}>
            <div className={Styles.HeaderGradientBar} />
            <div className={Styles.Header}>
              <img
                src={Favicon}
                alt="한국의약품안전관리원"
                className={Styles.LogoMini}
              />
              <span className={Styles.BrandName}>
                한국의약품안전관리원 상담봇
              </span>
            </div>
          </div>

          <div className={Styles.Content}>
            <div className={Styles.Character}>
              <img
                src={Logo}
                alt="한국의약품안전관리원"
                style={{
                  width: '200px',
                  height: '200px',
                  objectFit: 'cover',
                  borderRadius: '50%',
                  backgroundColor: 'transparent',
                }}
              />
            </div>
            <div className={Styles.LabelWrap}>
              <div className={Styles.Title}>
                <p>만료된 상담입니다.</p>
              </div>
              <ul className={Styles.Label}>
                <li>
                  <p>
                    오랫동안 상담을 시작하지 않는 경우 채팅상담 연결이
                    제한됩니다.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

QvExpired.propTypes = {};

export default QvExpired;
